/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Usage Unit Type
 */
export enum UsageUnitType {
    Uses = 'Uses',
    Cities = 'Cities',
}
